export const contentGuide = ({ content: { contentGuide } }: Flipboard.State) =>
  contentGuide;
